import React from "react";
import InquiryForm from "@/components/InquiryForm";
import { Handshake, TrendingUp, ShieldCheck, Megaphone } from "lucide-react";

const DealerPage = () => {
  return (
    <div data-testid="dealer-page">
      <section className="border-b border-line relative overflow-hidden">
        <div className="pointer-events-none absolute -top-32 -right-40 h-96 w-96 rounded-full bg-[#dd0447]/10 blur-[120px]" />
        <div className="mx-auto max-w-7xl px-6 py-20 lg:px-10">
          <div className="overline mb-4"><Handshake className="mr-2 inline-block h-4 w-4" /> Partnership program</div>
          <h1 className="font-display max-w-3xl text-5xl font-black leading-[0.95] tracking-tight text-ink md:text-6xl">
            Become an
            <br />
            <span className="text-[#dd0447]">AREL dealer.</span>
          </h1>
          <p className="mt-8 max-w-2xl text-lg leading-relaxed text-muted-warm">
            Bring premium home appliances to your city. Join our growing
            network of dealers across all 7 provinces of Nepal.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-6 py-20 lg:px-10">
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {[
            { icon: TrendingUp, title: "Attractive margins", body: "Dealer pricing structured for healthy retail margins." },
            { icon: ShieldCheck, title: "Reliable supply", body: "Priority stock allocation and predictable ETAs." },
            { icon: Megaphone, title: "Marketing kits", body: "Branding, POS materials & seasonal campaigns support." },
            { icon: Handshake, title: "Regional exclusivity", body: "Territory-first dealership options in select regions." },
          ].map((b, i) => (
            <div key={i} className="arel-card rounded-xl p-6" data-testid={`dealer-benefit-${i}`}>
              <div className="flex h-11 w-11 items-center justify-center rounded-md bg-[#dd0447]/10 text-[#dd0447]">
                <b.icon className="h-5 w-5" />
              </div>
              <div className="mt-4 font-display text-lg font-bold text-ink">{b.title}</div>
              <div className="mt-2 text-sm text-muted-warm">{b.body}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="border-t border-line bg-[#f4f1ec] py-20">
        <div className="mx-auto max-w-3xl px-6 lg:px-10">
          <div className="arel-card rounded-2xl p-8 md:p-10">
            <div className="overline mb-4">Apply</div>
            <div className="mb-6 font-display text-3xl font-bold text-ink">Dealer inquiry</div>
            <p className="mb-8 text-sm text-muted-warm">
              Fill out the form and our partnerships team will contact you
              within 48 hours.
            </p>
            <InquiryForm
              inquiryType="dealer"
              subject="Dealer Application"
              testIdPrefix="dealer"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default DealerPage;
